import React, { createContext, useContext, useReducer } from 'react';
import {
  errorReducer,
  initErrorState,
  initialErrorState,
} from './PowerPointIngestionErrorHandling';

const IngestionErrorsStateContext = createContext(null);
const IngestionErrorsDispatchContext = createContext(null);

function useIngestionErrorsState() {
  const context = useContext(IngestionErrorsStateContext);
  if (context === undefined) {
    throw new Error(
      'useIngestionErrorsState must be used within an IngestionErrorsProvider'
    );
  }
  return context;
}

function useIngestionErrorsDispatch() {
  const context = useContext(IngestionErrorsDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useIngestionErrorsDispatch must be used within an IngestionErrorsProvider'
    );
  }
  return context;
}
function useIngestionErrors() {
  return [useIngestionErrorsState(), useIngestionErrorsDispatch()];
}

const IngestionErrorsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    errorReducer,
    initialErrorState,
    initErrorState
  );

  return (
    <IngestionErrorsStateContext.Provider value={state}>
      <IngestionErrorsDispatchContext.Provider value={dispatch}>
        {children}
      </IngestionErrorsDispatchContext.Provider>
    </IngestionErrorsStateContext.Provider>
  );
};
export {
  IngestionErrorsProvider,
  useIngestionErrorsState,
  useIngestionErrorsDispatch,
  useIngestionErrors,
};
